export default __webpack_public_path__ + "static/preview-88099d3f61913bc732919dec0120acaf.png";